<template>
  <div class="app" v-if="hasMapPortalAccess && termsOfUseChecked">
    <header id="header-page">
      <h1 hidden="hidden">{{ pagetitle }}</h1>
      <app-header></app-header>
    </header>
    <main>
      <system-unavailable-overlay v-if="showSystemUnavailable" />
      <no-organization-overlay v-else-if="!contextIsAnonymous && showNoOrganization"/>
      <no-roles-permission-denied-overlay v-else-if="(!contextIsAnonymous && showNoRoles)" />
      <permission-denied-overlay v-else-if="(!contextIsAnonymous && !havePermissions)" />
      <global-error-overlay v-else-if="$context.state.globalError"/>
      <template v-else>
        <api-error-window></api-error-window>
        <migration-error-window></migration-error-window>
        <map-view :key="this.contextOrganizationId"></map-view>
      </template>
    </main>
    <notification-toast />
  </div>
</template>

<script>
import AppHeader from './components/Header';
import MapView from './components/MapView';
import ApiErrorWindow from './components/ApiErrorWindow';
import MigrationErrorWindow from './components/MigrationErrorWindow';
import NotificationToast from './components/NotificationToast';
import {
  RESPONSIVE_VERSION_SET_IF_MOBILE_DEVICE,
  RESPONSIVE_VERSION_SET_IF_MOBILE_VERSION
} from './store/mutations.type';
import { RESPONSIVE_VERSION_CHECK_IF_MOBILE } from './store/actions.type';
import { Api as ApiAuth } from './api/api-auth';
import NoOrganizationOverlay from "./components/InformationOverlay/NoOrganizationOverlay.vue";
import PermissionDeniedOverlay from "./components/InformationOverlay/PermissionDeniedOverlay.vue";
import SystemUnavailableOverlay from "./components/InformationOverlay/SystemUnavailableOverlay.vue";
import GlobalErrorOverlay from "./components/InformationOverlay/GlobalErrorOverlay.vue";
import NoRolesPermissionDeniedOverlay from "./components/InformationOverlay/NoRolesPermissionDeniedOverlay.vue";
var contextInstance = require('./api/ContextInstance.js').default;

export default {
  name: 'App',
  data() {
    return {
      pagetitle: 'Widok mapy PIT',
      termsOfUseChecked: false
    };
  },
  components: {
    NoRolesPermissionDeniedOverlay,
    GlobalErrorOverlay,
    SystemUnavailableOverlay,
    PermissionDeniedOverlay,
    NoOrganizationOverlay,
    AppHeader,
    MapView,
    ApiErrorWindow,
    MigrationErrorWindow,
    NotificationToast
  },
  mounted() {
    const self = this;
    const apiAuth = new ApiAuth();
    if (!process.env.UKEPROD && !process.env.UKETST) {
      self.termsOfUseChecked = true;
    } else {
      const termsOfUse = apiAuth
        .getTermsOfUse()
        .then(response => {
          const termsOfUse = response.body;
          if (termsOfUse) {
            if (!termsOfUse.accepted) {
              window.location.href = termsOfUse.url;
            }
            contextInstance.setTermsOfUseError(false);
          } else {
            contextInstance.setTermsOfUseError(true);
          }
        })
        .catch(_ => {
          contextInstance.setTermsOfUseError(true);
        })
        .finally(_ => {
          self.termsOfUseChecked = true;
        });
    }

    if (!this.hasMapPortalAccess) {
      window.location.href = '/admin';
    }
  },
  async beforeCreate() {
    const ifMobile = await this.$store.dispatch(
      RESPONSIVE_VERSION_CHECK_IF_MOBILE
    );
    this.$store.commit(RESPONSIVE_VERSION_SET_IF_MOBILE_DEVICE, ifMobile);
    this.$store.commit(RESPONSIVE_VERSION_SET_IF_MOBILE_VERSION, ifMobile);
  }
};
</script>

<style>
html,
body {
  height: 100%;
}

main {
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  min-height: 0;
  position: relative; /* Hack - Safari won't set child element's height to 100% when parent's height is 'auto'*/
}
.app {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  justify-content: flex-start;
  -webkit-align-items: stretch;
  align-items: stretch;
  -webkit-align-content: stretch;
  align-content: stretch;
}

#permission-info {
  position: absolute;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  top: 15%;
}

#info-row {
  max-width: 75%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

#info-row > div > div.row.text-center.pt-1.pb-5 > div > p {
  font-size: 1.4rem;
}
#info-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
}
.link-underlined {
  text-decoration: underline;
}
</style>

<style lang="scss">
@import 'Style/app.scss';
@import 'Style/contrast.scss';
@import 'Style/fontsSize.scss';
</style>
